import { useMutation } from '@apollo/client'
import { createOrganization as createOrganizationGql }
   from 'src/graphql/mutations/createOrganization.gql'

const useCreateOrganization = (mutationHookOptions) => {
   const [createOrganization, { called, client, data, error, loading }] =
      useMutation(createOrganizationGql, mutationHookOptions)

   const wrappedMutationFn = (input, mutationFnOptions) => createOrganization({
      variables: { input },
      ...mutationFnOptions
   })

   return {
      createOrganization: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useCreateOrganization
